module.exports = __webpack_public_path__ + "img/main-bg.c339d880.jpg";